import type { Player } from '../../types';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import styles from './JailDialog.module.css';

interface Props {
  player: Player;
  onPayBail: () => void;
  onTryDoubles: () => void;
}

export default function JailDialog({ player, onPayBail, onTryDoubles }: Props) {
  const canAfford = player.money >= 200;

  // 10秒倒计时，默认尝试掷双数（免费）
  const { countdown, cancelAutoConfirm } = useAutoConfirm({
    onAutoConfirm: onTryDoubles,
    delayMs: 10000,
    enabled: true,
  });

  const handlePay = () => {
    cancelAutoConfirm();
    onPayBail();
  };

  const handleDoubles = () => {
    cancelAutoConfirm();
    onTryDoubles();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <span className={styles.emoji}>🚔</span>
          <h3 className={styles.title}>你在监狱中</h3>
          <div className={styles.subtitle}>需要掷出双数或支付保释金才能出狱</div>
        </div>

        <div className={styles.details}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>剩余刑期</span>
            <span className={styles.detailValue}>{player.jailTurns} 回合</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>保释费用</span>
            <span className={styles.detailValue}>💰 ¥200</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>当前余额</span>
            <span className={`${styles.detailValue} ${!canAfford ? styles.insufficient : ''}`}>
              ¥{player.money.toLocaleString()}
            </span>
          </div>
        </div>

        <div className={styles.actions}>
          <button
            className={`${styles.btn} ${styles.btnBail}`}
            onClick={handlePay}
            disabled={!canAfford}
          >
            {canAfford ? '支付 ¥200 保释出狱' : '余额不足'}
          </button>
          <button
            className={`${styles.btn} ${styles.btnDoubles}`}
            onClick={handleDoubles}
          >
            尝试掷出双数
          </button>
        </div>

        <div className={styles.countdown}>⏰ {countdown}s 后自动尝试掷双数</div>
      </div>
    </div>
  );
}
